// src/pages/Jurnal.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCalendarDay, FaCalendarAlt } from 'react-icons/fa';
import BottomNavbar from '../components/BottomNavbar';
import logo from '../assets/EPRAJOGO1.png';

function Jurnal() {
  const navigate = useNavigate();

  const cards = [
    {
      icon: <FaCalendarDay size={24} />,
      title: 'Jurnal Harian',
      route: '/jurnal-harian',
      bg: 'primary',
      description: 'Catat pekerjaan dan kegiatan PKL setiap hari.',
    },
    {
      icon: <FaCalendarAlt size={24} />,
      title: 'Jurnal Mingguan',
      route: '/jurnal-mingguan',
      bg: 'success',
      description: 'Susun rencana dan unggah dokumentasi mingguan.',
    },
  ];

  return (
    <main className="app-mobile-page">
      <header className="app-brand-header">
        <div className="app-brand-row">
          <img src={logo} alt="Logo E-Prajogo" className="app-brand-logo" />
          <div><p className="app-brand-name">E-PRAJOGO</p><p className="app-brand-school">SMK NEGERI GUDO</p></div>
          <span className="ms-auto rounded-pill px-3 py-2 small fw-semibold" style={{ background: '#ffffff20', color: '#fff' }}>SISWA</span>
        </div>
        <h1 className="app-header-title">Jurnal PKL</h1>
        <p className="app-header-subtitle">Pilih jurnal harian atau mingguan untuk melanjutkan.</p>
      </header>

      <section className="app-content">
        <h2 className="h5 fw-bold mb-1">Jenis jurnal</h2>
        <p className="small text-muted mb-3">Semua pengajuan dapat dipantau status verifikasinya.</p>
        <div className="d-grid gap-3">
        {cards.map((card, idx) => (
          <button className="journal-type-card" type="button" key={idx} onClick={() => navigate(card.route)}>
            <div className={`journal-type-icon bg-${card.bg}`}>{card.icon}</div>
            <div className="text-start flex-grow-1"><strong>{card.title}</strong><span>{card.description}</span></div>
            <span className="journal-type-arrow" aria-hidden="true">›</span>
          </button>
        ))}
        </div>
      </section>
      <BottomNavbar />
    </main>
  );
}

export default Jurnal;
